import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from './PrivacySheet.module.scss';
export default function PrivacyUseSheet() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><Text as="p" category="caption" variant="sb1" color="var(--color-gray-800)">서비스(회사): 이실장(프롭티어(주))</Text><Text as="p" category="body" variant="r2" color="var(--color-gray-800)">서비스의 개인정보 수집 이용 목적은 다음과 같습니다. 내용을 자세히 읽어 보신 후 동의 여부를 결정하여 주시기 바랍니다.</Text></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <tr><th scope="row"><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-600)">수집 목적</Text></div></th><td><Text category="body" variant="r2" color="var(--color-gray-600)">본인확인 및 안심케어 서비스 관련 사항 안내</Text></td></tr>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <tr><th scope="row"><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-600)">수집 항목</Text></div></th><td><Text category="body" variant="r2" color="var(--color-gray-600)">이름, 휴대폰번호, 거래희망소재지(상담 시)</Text></td></tr>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <th scope="row" className={styles.tableStrongCell}><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-800)">보유·이용기간</Text></div></th>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <table className={styles.table}><tbody>{t1}{t2}<tr>{t3}<td className={styles.tableStrongCell}><div className={styles.tdCell}><Text category="caption" variant="sb2" color="var(--color-gray-800)">수집일부터 12개월 까지</Text></div></td></tr></tbody></table>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text as="p" category="body" variant="r2" color="var(--color-gray-800)">자세한 내용은 아래 개인정보처리방침을 확인해주세요.</Text>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.PrivacySheet}>{t0}{t4}<div className={styles.container}>{t5}<Link href="https://www.aipartner.com/html/privacy" target="_blank" rel="noopener noreferrer"><Text as="p" category="body" variant="r2" color="var(--color-blue-500)">https://www.aipartner.com/html/privacy</Text></Link><Text as="p" category="body" variant="r2" color="var(--color-gray-800)">귀하는 위와 같이 개인정보 제공하는데 동의를 거부할 권리가 있습니다. 단, 동의를 거부하실 경우 서비스 이용이 제한됩니다.</Text></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}